import { Component, type ErrorInfo, type ReactNode } from 'react';
import { logger } from '@/services/logger/logger';
import { reportError } from '@/services/errorHandler/globalErrorHandler';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    logger.error('ErrorBoundary caught an error', { componentStack: errorInfo.componentStack }, error);
    reportError(error, { extra: { componentStack: errorInfo.componentStack } });
  }

  render(): ReactNode {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className={styles.root} role="alert">
          <h1 className={styles.title}>Что-то пошло не так</h1>
          <p className={styles.message}>{this.state.error.message}</p>
          <button
            type="button"
            className={styles.button}
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Попробовать снова
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
